// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"568":"9eed9c30","821":"a8703517"}[chunkId] + ".chunk.css";
};